import { render, staticRenderFns } from "./balancePayment.vue?vue&type=template&id=70f98e06&scoped=true&"
import script from "./balancePayment.vue?vue&type=script&lang=js&"
export * from "./balancePayment.vue?vue&type=script&lang=js&"
import style0 from "./balancePayment.vue?vue&type=style&index=0&id=70f98e06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f98e06",
  null
  
)

export default component.exports